import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import analytics from '../../analytics';
import routes, { currentRoute } from '../../routes';
import Dialogs from '../dialogs/a11y-dialog-component';
import * as globalE from '../globalE';
import OnRenderWrapper from '../utils/OnRenderWrapper';
import Popins from './Popins';
export const filterPopins = (popins) => {
    const results = [];
    const globalEData = globalE.getGlobalEData();
    // Filter per page & country
    const filteredPopins = popins.filter((popin) => {
        const checkPages = popin.pages.length > 0
            ? popin.pages.includes(window.location.pathname) || popin.pages.includes(currentRoute)
            : true;
        const checkCountries = popin.countries.length > 0 ? !!globalEData && popin.countries.includes(globalEData.countryISO) : true;
        const checkRegions = !!popin.regions && popin.regions.length > 0
            ? !!globalEData?.regionCode &&
                popin.regions.find((region) => region.countryCode === globalEData.countryISO && region.regions.includes(globalEData.regionCode))
            : true;
        return checkPages && checkCountries && checkRegions;
    });
    // Format
    const classics = filteredPopins.filter((popin) => popin.format === 'popin');
    const classic = classics.find((popin) => popin.countries.length === 0) || classics[0];
    const banner = filteredPopins.find((popin) => popin.format === 'banner');
    const centered = filteredPopins.find((popin) => popin.format === 'centered');
    const edging = filteredPopins.find((popin) => popin.format === 'edging');
    const optin = filteredPopins.find((popin) => popin.format === 'optin');
    const optinCentered = filteredPopins.find((popin) => popin.format === 'optin_centered');
    if (classic) {
        results.push(classic);
    }
    if (banner) {
        results.push(banner);
    }
    if (centered) {
        results.push(centered);
    }
    if (edging) {
        results.push(edging);
    }
    if (optin) {
        results.push(optin);
    }
    if (optinCentered) {
        results.push(optinCentered);
    }
    return results;
};
const onPopinsRendered = () => {
    const containerPopins = document.getElementById('popins');
    // popin dialog
    const dialogPopinId = 'dialog-popin';
    const dialog = document.getElementById(dialogPopinId);
    if (dialog && dialog.dataset) {
        const { onlyOnce } = dialog.dataset;
        if (onlyOnce === '0' ||
            (onlyOnce === '1' && window.localStorage.getItem(`popin-${dialog.dataset.popinId}`) === null)) {
            if (onlyOnce === '1') {
                window.localStorage.setItem(`popin-${dialog.dataset.popinId}`, '1');
            }
            Dialogs.create(dialogPopinId, {
                labelledbyId: 'dialog-popin-title',
                describedbyId: 'dialog-popin-desc',
                show: true,
                modal: false,
                backdrop: false,
                disableScroll: false,
            });
            analytics.dynamicPopin('Popin classic');
        }
    }
    // popin dialog centered
    const dialogCenteredId = 'dialog-centered';
    const dialogCentered = document.getElementById(dialogCenteredId);
    if (dialogCentered && dialogCentered.dataset) {
        const { onlyOnce } = dialogCentered.dataset;
        if (onlyOnce === '0' ||
            (onlyOnce === '1' && window.localStorage.getItem(`popin-${dialogCentered.dataset.popinId}`) === null)) {
            if (onlyOnce === '1') {
                window.localStorage.setItem(`popin-${dialogCentered.dataset.popinId}`, '1');
            }
            Dialogs.create(dialogCenteredId, {
                labelledbyId: 'dialog-centered-title',
                describedbyId: 'dialog-centered-desc',
                show: true,
                onOpen: () => {
                    // centered modal with backdrop
                    containerPopins.classList.add('is-modal-backdrop-show');
                },
                onClose: () => {
                    containerPopins.classList.remove('is-modal-backdrop-show');
                },
            });
            analytics.dynamicPopin('Popin centered');
        }
    }
    // popin dialog edging
    const dialogEdgingId = 'dialog-edging';
    const dialogEdging = document.getElementById(dialogEdgingId);
    if (dialogEdging && dialogEdging.dataset) {
        const { onlyOnce } = dialogEdging.dataset;
        if (onlyOnce === '0' ||
            (onlyOnce === '1' && window.localStorage.getItem(`popin-${dialogEdging.dataset.popinId}`) === null)) {
            if (onlyOnce === '1') {
                window.localStorage.setItem(`popin-${dialogEdging.dataset.popinId}`, '1');
            }
            Dialogs.create(dialogEdgingId, {
                labelledbyId: 'dialog-edging-title',
                describedbyId: 'dialog-edging-desc',
                show: true,
                onOpen: () => {
                    // centered modal with backdrop
                    containerPopins.classList.add('is-modal-backdrop-show');
                },
                onClose: () => {
                    containerPopins.classList.remove('is-modal-backdrop-show');
                },
            });
            analytics.dynamicPopin('Popin edging');
        }
    }
    // banner dialog
    const dialogBannerId = 'dialog-banner';
    const dialogBanner = document.getElementById(dialogBannerId);
    if (dialogBanner && dialogBanner.dataset) {
        const { onlyOnce } = dialogBanner.dataset;
        if (onlyOnce === '0' ||
            (onlyOnce === '1' && window.localStorage.getItem(`banner-${dialogBanner.dataset.popinId}`) === null)) {
            if (onlyOnce === '1') {
                window.localStorage.setItem(`banner-${dialogBanner.dataset.popinId}`, '1');
            }
            Dialogs.create(dialogBannerId, {
                labelledbyId: 'dialog-banner-title',
                describedbyId: 'dialog-banner-desc',
                show: true,
                modal: false,
                backdrop: false,
                disableScroll: false,
                onOpen: () => {
                    containerPopins.classList.add('is-banner-show');
                },
                onClose: () => {
                    containerPopins.classList.remove('is-banner-show');
                },
            });
            analytics.dynamicPopin('Popin banner');
        }
    }
    // Note: Optin and Optin Centered dialogs are now initialized within the PopinOptin component
    // after async data loading completes. This ensures the dialog element exists before initialization.
};
export default async () => {
    if (routes.popins) {
        const popinsResponse = await fetch(routes.popins).then((response) => response.json());
        const popins = filterPopins(popinsResponse || []);
        const popinsRoot = createRoot(document.getElementById('popins'));
        popinsRoot.render(_jsx(OnRenderWrapper, { onRenderCallback: onPopinsRendered, children: _jsx(Popins, { popins: popins }) }));
    }
};
